
const types = {
  SET_SELECTED_LINE: 'APISNEEDS/SET_SELECTED_LINE',
};

export const initialState = {
  manual:{
    phoneNumber: null
  },
};

const ApisNeedsManualReducer = (state, action) => {
  switch (action.type) {
    case types.SET_SELECTED_LINE: {
      const { phoneNumber } = action.payload;
      return {
        ...state,
        manual :{
          phoneNumber,
        }
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setSelectedLine: phoneNumber => ({
    type: types.SET_SELECTED_LINE,
    payload: {
      phoneNumber,
    },
  }),
};

export default ApisNeedsManualReducer;
